module.exports = __webpack_public_path__ + "static/media/price-match.756c5e1f.png";